var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldRupeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_577_27865)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12,
    r: 7.49287,
    fill: "url(#paint0_linear_577_27865)",
    stroke: "url(#paint1_linear_577_27865)",
    strokeWidth: 1.01426
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4612,
    cy: 11.961,
    r: 7.09459,
    fill: "url(#paint2_linear_577_27865)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0597 15.6365L11.3181 12.5981V11.882H11.8986C12.1309 11.882 12.334 11.8497 12.5082 11.7852C12.6888 11.7143 12.8372 11.6143 12.9533 11.4853C13.0758 11.3562 13.1597 11.2014 13.2048 11.0208H11.3181V10.3047H13.1952C13.1565 10.137 13.0887 9.98862 12.992 9.85959C12.9017 9.73057 12.7791 9.63058 12.6243 9.55962C12.4759 9.48221 12.2953 9.4435 12.0825 9.4435H11.3181V8.72743H15.6818V9.4435H14.1627C14.2724 9.56607 14.3627 9.69832 14.4336 9.84024C14.511 9.98216 14.5626 10.137 14.5884 10.3047H15.6818V11.0208H14.6078C14.5433 11.4982 14.3594 11.8723 14.0563 12.1433C13.7531 12.4078 13.3629 12.5884 12.8855 12.6852L14.7819 15.6365H13.0597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_577_27865",
    x: 0.803958,
    y: 0.373672,
    width: 25.3921,
    height: 25.3921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.06971
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.34802
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_577_27865"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_577_27865",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_27865",
    x1: 21.18,
    y1: 19.68,
    x2: 6.78,
    y2: 4.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_27865",
    x1: 7.5,
    y1: 7.33333,
    x2: 16.8333,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_577_27865",
    x1: 9.83142,
    y1: 8.99918,
    x2: 19.4981,
    y2: 19.9992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5E1C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldRupeIcon);
export default __webpack_public_path__ + "static/media/gold_rupe_icon.083f21dea433b3870cf3cc867ca10170.svg";
export { ForwardRef as ReactComponent };